export default function getDefaultBackendData() {
  return {
    games: [],
    isPreloading: true,
    seasons: [],
  };
}
